import eventBus from './eventBus';
import Snackbar from './Snackbar.vue';

const SnackbarPlugin = {
  install(Vue, options = {}) {
    if (this.installed) {
      return;
    }

    this.installed = true;

    const componentName = options.componentName || 'Snackbar';

    Vue.prototype.$showSnackbar = ({ message, isError }) => {
      eventBus.$emit('show', { message, isError });
    };

    Vue.component(componentName, Snackbar);
  },
};

export default SnackbarPlugin;
